import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const Section = (props: Props) => {
  return (
    <section className={`space-y-4 ${props?.className}`}>
      {props.children}
    </section>
  );
};

export default Section;
